module.exports={author:"torrin a. greathouse",date:"9/20/2021",publishDate:"9/20/2021",highlighted:!1,tags:"",badge:"",title:"It's Blood That Makes Men Hard"};